module.exports = __webpack_public_path__ + "static/media/main-bg-2.f03b3033.jpg";